module.exports = __webpack_public_path__ + "img/blue-circle-table-3.3d5648df.png";